import React from 'react';
import FundingMetricGrid from './FundingMetricGrid';

const formatCurrency = (value) => {
  if (value == null || value === '') return '$0';
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }).format(value);
};

const FundingReportMetricGrid = ({ metrics = [] }) => (
  <FundingMetricGrid metrics={metrics} />
);

export const buildSummaryMetrics = (data) => {
  if (!data) return [];
  return [
    { id: 'clients', label: 'Total Clients', value: String(data.totalClients ?? 0), delta: 'Funding roster' },
    { id: 'ready', label: 'Ready Clients', value: String(data.readyClients ?? 0), delta: 'Good or Excellent readiness' },
    { id: 'docs', label: 'Document Complete', value: String(data.documentCompleteClients ?? 0), delta: 'Complete packages' },
    { id: 'submissions', label: 'Submissions', value: String(data.submissionsCreated ?? 0), delta: 'Created in range' },
    { id: 'active-deals', label: 'Active Deals', value: String(data.activeDeals ?? 0), delta: 'Pipeline in progress' },
    { id: 'funded-deals', label: 'Funded Deals', value: String(data.fundedDeals ?? 0), delta: 'Closed in pipeline' },
    { id: 'requested', label: 'Requested', value: formatCurrency(data.totalRequestedAmount), delta: 'Estimated pipeline' },
    { id: 'approved', label: 'Approved', value: formatCurrency(data.totalApprovedAmount), delta: 'Estimated approved' },
    { id: 'funded', label: 'Funded', value: formatCurrency(data.totalFundedAmount), delta: 'Estimated funded' },
    { id: 'projected', label: 'Projected', value: formatCurrency(data.projectedCommissions), delta: 'Commission forecast' },
    { id: 'earned', label: 'Earned', value: formatCurrency(data.earnedCommissions), delta: 'Earned commissions' },
    { id: 'paid', label: 'Paid', value: formatCurrency(data.paidCommissions), delta: 'Paid commissions' },
    { id: 'clawback', label: 'Clawback Risk', value: formatCurrency(data.clawbackRiskAmount), delta: 'At-risk amount' },
  ];
};

export default FundingReportMetricGrid;
